enum PreQualificationLetterRoles {
  BORROWER = 'BORROWER',
  CO_BORROWER = 'CO_BORROWER',
}

export default PreQualificationLetterRoles;
